import { associatedIncomePages } from './associatedIncomePages';

export default {
  title: 'Financial accounts',
  pages: associatedIncomePages,
};
